import { Button } from "@material-ui/core";
import FormControl from "../../components/formControl";
import CustomDropdown from "../../components/presentationals/CustomDropdown";
import { getLastSixMonths } from "../../utils/common";
import { schemeCountDashboardNames } from "../../utils/constants";
import SchemeOverviewTable from "./component";

const SchemeOverviewView = ({
  searchFields,
  setSearchFields,
  onRunClick,
  downloadCSVData,
  schemeOverview,
  page,
  rowsPerPage,
  setPage,
  setRowsPerPage,
}) => {
  return (
    <div className="container-fluid">
      <div className="whitebox mt-2 mb-1">
        <form autoComplete="off">
          <FormControl variant="outlined" type="form" styleName="formControl">
            <CustomDropdown
              name={"Dashboard Name"}
              data={schemeCountDashboardNames}
              changeHandler={(value) =>
                setSearchFields((prev) => ({ ...prev, moduleName: value }))
              }
              value={searchFields?.moduleName}
            />
          </FormControl>
          <FormControl variant="outlined" type="form" styleName="formControl">
            <CustomDropdown
              name={"Month"}
              data={getLastSixMonths()}
              changeHandler={(value) =>
                setSearchFields((prev) => ({
                  ...prev,
                  month: value?.value,
                }))
              }
              value={
                getLastSixMonths()?.filter(
                  (item) => item?.value === searchFields?.month
                )?.[0]
              }
              labelFieldName={"name"}
            />
          </FormControl>
          <FormControl variant="outlined" type="form" styleName="formControl">
            <Button
              onClick={(e) => {
                e.preventDefault();
                onRunClick();
              }}
              variant="contained"
              color="default"
              // disabled
            >
              Run
            </Button>
          </FormControl>
        </form>
      </div>
      <div className="d-flex align-items-center justify-content-between">
        <h2
          className="pagetitle wow fadeInUp"
          data-wow-delay=".5s"
          data-wow-duration="0.7s"
        >
          Scheme Overview Dashboard
        </h2>
        <div className="downloadarrow mb-2">
          <button
            type="button"
            className="btn btn-link btn-sm m-3 p-2"
            onClick={() => downloadCSVData()}
          >
            <img
              src={
                process.env.PUBLIC_URL +
                "/assets/images/icons/download-arrow.svg"
              }
              alt="download"
            />
          </button>
        </div>
      </div>
      <SchemeOverviewTable
        searchFields={searchFields}
        setSearchFields={setSearchFields}
        schemeOverview={schemeOverview}
        page={page}
        rowsPerPage={rowsPerPage}
        setPage={setPage}
        setRowsPerPage={setRowsPerPage}
      />
    </div>
  );
};

export default SchemeOverviewView;
